// 菜单权限映射
export const MENU_PERMISSION_MAP: Record<string, number> = {
  // 数据管理模块
  数据管理: 3,
  数据包管理: 72,
  分包日志: 84,

  // 个人中心模块
  个人中心: 15,

  // 系统管理模块
  系统管理: 19,
  角色管理: 20,
  账号管理: 25,

  // 外呼管理模块
  外呼管理: 31,
  外呼方管理: 32,

  // 撞库管理模块
  撞库管理: 37,
  撞库任务管理: 4,
  底包管理: 5,
  能力源管理: 38,
  能力源账号管理: 43,
  模型管理: 49,
  产品管理: 59,
  运营商管理: 86,
} as const;

// 功能权限映射
export const FUNCTION_PERMISSION_MAP: Record<string, number> = {
  // 数据包管理功能
  查询数据包: 73,
  新增数据包: 74,
  编辑数据包: 75,
  删除数据包: 76,
  数据包组合: 78,
  数据包拆包: 79,
  数据包分包: 80,
  获取FTP数据包: 81,

  // 分包日志功能
  查看分包日志: 82,

  // 个人中心功能
  查询个人信息: 16,
  修改个人信息: 17,
  修改密码: 18,

  // 角色管理功能
  查询角色: 21,
  新增角色: 22,
  编辑角色: 23,
  删除角色: 24,
  查询权限树: 91,

  // 账号管理功能
  查询账号: 26,
  新增账号: 27,
  编辑账号: 28,
  删除账号: 29,
  重置密码: 30,

  // 外呼方管理功能
  查询外呼方: 33,
  新增外呼方: 34,
  编辑外呼方: 35,
  删除外呼方: 36,

  // 撞库任务管理功能
  查询撞库任务: 64,
  新增撞库任务: 65,
  编辑撞库任务: 66,
  删除撞库任务: 67,

  // 底包管理功能
  查询底包: 68,
  新增底包: 69,
  编辑底包: 70,
  删除底包: 71,
  上传底包: 85,

  // 能力源管理功能
  查询能力源: 39,
  新增能力源: 40,
  编辑能力源: 41,
  删除能力源: 42,

  // 能力源账号管理功能
  查询能力源账号: 44,
  新增能力源账号: 45,
  编辑能力源账号: 46,
  删除能力源账号: 47,
  重置能力源账号密码: 48,

  // 模型管理功能
  查询模型: 55,
  新增模型: 56,
  编辑模型: 57,
  删除模型: 58,

  // 模型组管理功能
  模型组管理: 50,
  查询模型组: 51,
  新增模型组: 52,
  编辑模型组: 53,
  删除模型组: 54,

  // 产品管理功能
  查询产品: 60,
  新增产品: 61,
  编辑产品: 62,
  删除产品: 63,

  // 运营商管理功能
  查询运营商: 87,
  新增运营商: 88,
  编辑运营商: 89,
  删除运营商: 90,
} as const;

// 路由权限映射
export const ROUTE_PERMISSION_MAP: Record<string, number> = {
  "/dashboard": 1,
  "/geofence": 1,
  "/attendance-map": 1,
  "/worker-attendance": 1,
  "/report-export": 1,
} as const;

// 导出权限映射
export const EXPORT_PERMISSION_MAP: Record<string, number> = {
  分包日志: 11,
  包名: 12,
  上传方: 13,
  上传数量: 14,
  数据包: 92,
} as const;

// 快速访问的权限ID常量
export const PERMISSION_IDS = {
  // 基础权限
  READ: "canRead",
  CREATE: "canCreate",
  UPDATE: "canUpdate",
  DELETE: "canDelete",

  // 系统管理
  MANAGE_ROLES: MENU_PERMISSION_MAP.角色管理,
  MANAGE_ACCOUNTS: MENU_PERMISSION_MAP.账号管理,

  // 数据管理
  MANAGE_DATA_PACKAGES: MENU_PERMISSION_MAP.数据包管理,
  VIEW_PACKAGE_LOGS: MENU_PERMISSION_MAP.分包日志,

  // 撞库管理
  MANAGE_CRACKING_TASKS: MENU_PERMISSION_MAP.撞库任务管理,
  MANAGE_BASE_PACKAGES: MENU_PERMISSION_MAP.底包管理,
  MANAGE_CAPABILITIES: MENU_PERMISSION_MAP.能力源管理,
  MANAGE_CAPABILITY_ACCOUNTS: MENU_PERMISSION_MAP.能力源账号管理,
  MANAGE_MODELS: MENU_PERMISSION_MAP.模型管理,
  MANAGE_PRODUCTS: MENU_PERMISSION_MAP.产品管理,
  MANAGE_OPERATORS: MENU_PERMISSION_MAP.运营商管理,

  // 外呼管理
  MANAGE_OUTBOUND_PARTIES: MENU_PERMISSION_MAP.外呼方管理,

  // 导出权限
  EXPORT_PACKAGE_LOGS: EXPORT_PERMISSION_MAP.分包日志,
} as const;
